import { Link, NavLink } from "react-router-dom";

import Logo from "../Logo/Logo";
import ColorSwitcher from "../ColorSwitcher/ColorSwitcher";
import styles from "./NavBar.module.css";

/**
 * Desktop header.
 *
 * `links` is supplied by the application shell so this component stays
 * a presentation concern. Phase 02 renders the wordmark only; the real
 * Home/Games/Learn/Profile information architecture arrives in Phase 04.
 */
const NavBar = ({ links = [], homeUrl = "/", children, onLinkIntent }) => {
  const linkClass = ({ isActive }) =>
    `${styles.link} ${isActive ? styles.active : ""}`.trim();

  return (
    <nav
      className={`${styles.NavBar} d-none d-lg-block`}
      aria-label="Main navigation"
    >
      <div className="container d-flex align-items-center gap-3">
        <Link
          to={homeUrl}
          className={styles.brand}
          aria-label="I don't know football, home"
        >
          <Logo size="md" animatedMark />
        </Link>

        {links.length > 0 && (
          <ul className={styles.links}>
            {links.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  className={linkClass}
                  end={link.end}
                  onFocus={() => onLinkIntent?.(link.to)}
                  onMouseEnter={() => onLinkIntent?.(link.to)}
                >
                  {link.icon && <i className={link.icon} aria-hidden="true" />}
                  <span>{link.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        )}

        <div className={styles.actions}>
          {children}
          <ColorSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
